module.exports = __webpack_public_path__ + "img/analysing-pad.039762c3.png";